module.exports = __webpack_public_path__ + "img/size10.4b7556f1.png";